/* eslint-disable import/prefer-default-export */
const defaultObj = {};

export const getAuthUserData = (state) => state.AuthUser.authUserData || defaultObj;
export const getAuthUserLodaing = (state) => state.AuthUser.loadingAuthUserData || false;

export const getGoogleSignupInfo = (state) => state.GoogleSignup.googleSignupInfo || defaultObj;
export const getGoogleSignupLoading = (state) => state.GoogleSignup.loadingGoogleSignupInfo || false;
export const getForgotPasswordInfo = (state) => state.ForgotPassword.forgotPasswordInfo || defaultObj;
export const getForgotPasswordInfoLoading = (state) => state.ForgotPassword.loadingForgotPasswordInfo || false;
